import { render } from "./publication.vue?vue&type=template&id=da018836&scoped=true"
import script from "./publication.vue?vue&type=script&lang=js"
export * from "./publication.vue?vue&type=script&lang=js"

import "./publication.vue?vue&type=style&index=0&id=da018836&scoped=true&lang=scss"

import exportComponent from "/home/duke/code/duke-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da018836"]])

export default __exports__